import { css } from '@emotion/css';
import PopupTooltip from 'components/tooltip-popup/PopupTooltip';
import { colors } from 'constants/theme';
import { LotteryTicket, TicketConfirmLotteryData } from 'models/lotteryModel';
import { useEffect, useState } from 'react';
import { formatCodeString } from 'utils/function';

interface Props {
    ticketData: TicketConfirmLotteryData;
    ticketList: LotteryTicket[];
    onSubmit: () => void;
    onClose: () => void;
}
function ConfirmBetLottery(props: Props) {
    const { onClose, onSubmit, ticketData, ticketList } = props;
    const [, setTicketInfo] = useState(ticketData);
    useEffect(() => {
        setTicketInfo(ticketData);
    }, [ticketData, ticketList]);

    return (
        <div className={styles.wrap}>
            <div className={styles.headerConfirm}>
                <p>Xác nhận</p>
                <button type="button" onClick={onClose}>
                    <img alt="" src={require('assets/images/icons/iconX.png')} className="iconX" />
                </button>
            </div>

            <div className={styles.confirm}>
                <p>Bạn có chắc cược ?</p>
            </div>

            <div className={styles.table}>
                <div className={styles.row}>
                    <div className={`${styles.col} ${styles.title}`}>Tên cược</div>
                    <div className={`${styles.col} ${styles.title}`} style={{ flex: '0 0 200px' }}>
                        Số cược
                    </div>
                    <div className={`${styles.col} ${styles.title}`}>Tổng cược</div>
                    <div className={`${styles.col} ${styles.title}`}>Cấp số nhân</div>
                    <div className={`${styles.col} ${styles.title}`}>Tiền cược</div>
                    <div className={`${styles.col} ${styles.title}`}>Tiền thắng/1 lần</div>
                    <div className={`${styles.col} ${styles.title}`}>Tỉ lệ</div>
                </div>
                <div className={styles.tableBody}>
                    {ticketList.map((item, index) => (
                        <div className={styles.row} key={index}>
                            <p className={`${styles.col}`} style={{ fontWeight: '500' }}>
                                {item.trTitle} - {item.stTitle}
                            </p>
                            <div className={`${styles.col} ${styles.codesBet}`} style={{ flex: '0 0 200px' }}>
                                <PopupTooltip content={formatCodeString(item.codes)} idRef={`confirm_${index}`} />
                            </div>
                            <p className={styles.col}>{item.total}</p>
                            <p className={styles.col}>{item.times}</p>
                            <p className={`${styles.col} `} style={{ fontWeight: '500' }}>
                                {new Intl.NumberFormat().format(item.money * item.times)}
                            </p>
                            <p className={styles.col}>{new Intl.NumberFormat().format(Number(item.dyprize.prize) * item.times * 1000)}</p>
                            <p className={styles.col}>{item.dyprize.prize}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className={styles.bottomView}>
                <p>
                    Tổng số tiền đặt cược: <span>{new Intl.NumberFormat().format(ticketList.reduce((acc, item) => acc + item.money * item.times, 0))}</span>
                    VNĐ
                </p>

                <div className={styles.actionGroup}>
                    <button type="button" className={styles.buttonOK} onClick={onSubmit}>
                        OK
                    </button>
                    <button type="button" className={`${styles.buttonCancel}`} onClick={onClose}>
                        Huỷ
                    </button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    wrap: css`
        /* padding: 20px 16px; */
        border-radius: 5px;
        background-color: white;
        overflow: hidden;
    `,
    headerConfirm: css`
        background-color: #f7f7f7;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 15px;
        padding-right: 15px;
        font-size: 16px;
        justify-content: space-between;
        display: flex;
        border-bottom: 1px solid #eee;
        .iconX {
            width: 20px;
            height: 20px;
            resize: cover;
        }
    `,

    confirm: css`
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 20px;

        p {
            font-size: 18px;
        }
    `,
    bottomView: css`
        display: flex;
        justify-content: space-between;
        padding-left: 20px;
        padding-right: 20px;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;
        span {
            font-weight: 500;
            color: ${colors.yellow};
            margin-right: 5px;
        }
    `,
    heading: css`
        color: ${colors.white};
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 24px;
        border-radius: 8px;
        margin-bottom: 16px;
        background: black;
        border: 1px solid ${colors.borderPrimary};

        h3 {
            font-size: 24px;
        }
        p {
            display: flex;
            align-items: center;
            gap: 6px;
        }
        span {
            font-size: 22px;
            color: ${colors.yellow};
            font-weight: 500;
        }
    `,

    table: css`
        /* border: 1px solid ${colors.primary}; */
        border-radius: 5px;
        overflow: hidden;
        min-height: 150px;
        color: ${colors.white};
        margin-left: 20px;
        margin-right: 20px;
        background-color: #e5e5e5;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    `,
    codesBet: css`
        word-wrap: break-word;
        max-width: 200px;
    `,
    row: css`
        display: flex;
        align-items: center;
        color: black;
        border-bottom: 1px solid #b7b7b7;
    `,
    col: css`
        flex: 1;
        padding: 8px 8px;
        text-align: center;
        font-size: 14px;
    `,
    title: css`
        font-weight: 300;
        background-color: #d0d0d0;
        color: black;
    `,
    actionGroup: css`
        display: flex;
        gap: 16px;
    `,
    tableBody: css`
        max-height: 500px;
        overflow-y: auto;
        background-color: #e5e5e5;
    `,
    buttonOK: css`
        border: 1px solid #c9820a !important;
        border-radius: 3px !important;
        color: #fff !important;
        background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
        padding-left: 20px;
        padding-right: 20px;
        text-align: center;
    `,
    buttonCancel: css`
        border-radius: 4px !important;
        border: 1px solid #d4d4d4;
        background: linear-gradient(to bottom, #dbdbdb 0%, #dbdbdb 28%, #d1d1d1 65%, #e6e6e6 100%);
        padding-left: 20px;
        padding-right: 20px;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
    `,
};

export default ConfirmBetLottery;
